import type { NavGroup } from './navigation-types';

// The finance-facing sidebar groups, split out of navigation.ts so each config
// file stays under the max-lines cap.
export const FINANCE_NAV_GROUPS: NavGroup[] = [
  {
    id: 'finance-views',
    label: 'Finance Views',
    items: [
      {
        id: 'gmv-overview',
        slug: 'finance/gmv',
        label: 'GMV Overview',
        iconKey: 'trending-up',
      },
      {
        id: 'revenue-overview',
        slug: 'finance/overview',
        label: 'Statutory PnL Overview',
        iconKey: 'pie-chart',
      },
      {
        id: 'cash-equivalents',
        slug: 'finance/cash-availability',
        label: 'Cash & Equivalents',
        iconKey: 'wallet',
      },
      {
        id: 'cash-flow-view',
        slug: 'finance/cash-flow',
        label: 'Cash Flow View',
        iconKey: 'arrow-right-left',
      },
      {
        id: 'payments-ledger',
        slug: 'finance/payments-ledger',
        label: 'Payments Ledger',
        iconKey: 'landmark',
      },
      {
        id: 'goods-in-transit',
        slug: 'finance/goods-in-transit',
        label: 'Goods in Transit',
        iconKey: 'package',
      },
    ],
  },
  {
    id: 'treasury-management',
    label: 'Treasury Management',
    items: [
      {
        id: 'data-tape',
        slug: 'finance/data-tape',
        label: 'Data Tape',
        iconKey: 'file-spreadsheet',
      },
      {
        // Roles mirror the backend guard on /data-tape/v2/*.
        id: 'data-tape-new',
        slug: 'finance/data-tape-new',
        label: 'Data Tape v2 (WIP)',
        iconKey: 'construction',
        requiredRoles: ['cfo', 'management', 'admin'],
      },
      // Roles mirror the backend guard on /data-tape/v2/declarations/*. The legacy
      // submissions entry was removed here (10 Aug); removing a nav entry also
      // unregisters its route, since routes derive from this list.
      {
        id: 'lender-declarations',
        slug: 'finance/data-tape-new/declarations',
        label: 'Lender Submission (WIP)',
        iconKey: 'send',
        requiredRoles: ['cfo', 'admin'],
      },
      {
        // Roles mirror the /data-tape/v2/caps read gate. The page is flag-gated
        // (data-tape-concentration-caps); the nav item is role-gated only (nav
        // has no flag field), so it shows for these roles even while the flag is
        // off — the page renders "not available" until the flag flips.
        id: 'concentration-caps',
        slug: 'finance/concentration-caps',
        label: 'Concentration Caps (WIP)',
        iconKey: 'pie-chart',
        requiredRoles: ['cfo', 'management', 'admin'],
      },
      {
        id: 'eligibility',
        slug: 'finance/eligibility',
        label: 'Eligibility',
        iconKey: 'shield',
      },
      {
        id: 'cash-balances',
        slug: 'finance/cash-balances',
        label: 'Cash Balances',
        iconKey: 'wallet',
      },
      {
        id: 'transactions',
        slug: 'finance/transactions',
        label: 'Transactions',
        iconKey: 'wallet',
      },
    ],
  },
];
